
import { useMutation, useQuery } from "react-query"
import { useToast } from "../../hook/usetoast";
import DataService from '../../config/DataServices'
import { queryClient } from "../../config";

const { postRequest,getRequest} = DataService()


export const useVerifyTFA = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/verify-tfa", {...data})
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }

            return toast.success(success?.message)
        }
    })
}

export const useGetVRS = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/withdraw-signature", {...data})
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }

        }
    })
}


export const useWithdraw = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/withdraw", {...data})
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            queryClient.refetchQueries("get-profile");
            queryClient.refetchQueries("get-withdraw");

            return toast.success(success?.message)
        }
    })
}

export const useGetWithDraw = ({page, size }) => {

    return useQuery({
        queryKey: ["get-withdraw" , page, size ],
        queryFn: () => {
            return getRequest(`user/withdraw?page=${page}&size=${size}`)
        }
    })
}
export const useGetKKOG = () => {

    return useQuery({
        queryKey: ["get-KKOG"],
        queryFn: () => {
            return getRequest(`user/currency_details`)
        }
    })
}




export const useUpdateWithDraw = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/update_withdraw_status", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            queryClient.refetchQueries("Withdrawal-history");

            return toast.success(success?.message)
        }
    })
}
